import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';

import AppRoutes from './AppRoutes';
import { setCsrfToken } from './utils/axiosInstance';

import './custom.css';

export default class App extends Component {
  static displayName = App.name;

    componentDidMount() {
    fetch('/auth/get-csrf-token', {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        if (data.csrfToken) {
          setCsrfToken(data.csrfToken);
        }
      })
      .catch(err => {
        console.error("Failed to fetch CSRF token:", err);
      });
  }

  render() {
    return (
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, ...rest } = route;
            return <Route key={index} {...rest} element={element} />;
          })}
        </Routes>
    );
  }
}
